import { render, staticRenderFns } from "./Requests.vue?vue&type=template&id=3240c502&scoped=true"
import script from "./Requests.vue?vue&type=script&lang=js"
export * from "./Requests.vue?vue&type=script&lang=js"
import style0 from "./Requests.vue?vue&type=style&index=0&id=3240c502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3240c502",
  null
  
)

export default component.exports